import { supabase } from "@/integrations/supabase/client";

/**
 * Normalizes phone number by removing spaces and non-breaking spaces
 * Example: "+56 9 4537 8046" → "+56945378046"
 */
export function normalizePhoneFront(v: string): string {
  if (!v) return '';
  let s = v.toString().trim().replace(/\u00A0/g, '').replace(/\s+/g, '');
  return s.startsWith('+') ? '+' + s.slice(1).replace(/\D/g, '') : s.replace(/\D/g, '');
}

/**
 * Helper to submit data via Lovable Cloud backend.
 * No more CORS issues - uses our own backend endpoint.
 */

type SendToGASPayload = Record<string, string>;
type SendToGASOptions = {
  source?: string;
};

export async function sendToGAS(
  payload: SendToGASPayload,
  opts?: SendToGASOptions
): Promise<{ ok: true }> {
  const source = opts?.source || 'unknown';

  try {
    const { data, error } = await supabase.functions.invoke('submit-lead', {
      body: payload,
    });

    if (import.meta.env.DEV) console.log('[submitToGAS] 📥 Respuesta del backend:', data);

    if (error) {
      console.error('[submitToGAS] ❌ Error del backend:', error);
      throw error;
    }

    if (!data?.success) {
      console.error('[submitToGAS] ❌ Error en respuesta:', data);
      throw new Error(data?.error || 'Error desconocido');
    }

    if (import.meta.env.DEV) console.log('[submitToGAS] ✅ Datos enviados correctamente al Sheet');
    return { ok: true };
    
  } catch (error) {
    console.error('[submitToGAS] ❌ Error:', error);
    throw error;
  }
}
